export default __webpack_public_path__ + "static/media/project3.8c5247a4.jpg";